"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAcceptedCommentSchema = exports.PostRequestDTOSchema = exports.closeTopicSchema = exports.isTopicClosed = exports.PostDTO = exports.PostSchema = exports.PostBaseSchema = void 0;
var zod_1 = require("zod");
var Channel_1 = require("./Channel");
var Comment_1 = require("./Comment");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var Like_1 = require("./Like");
var User_1 = require("./User");
exports.PostBaseSchema = zod_1.z.object({
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    views: zod_1.z.number().default(0),
    image: zod_1.z.string().optional(),
    imagePublicId: zod_1.z.string().optional(),
    pinned: zod_1.z.boolean().optional(),
    channel: zod_1.z.instanceof(ObjectId_1.ObjectId),
    author: zod_1.z.instanceof(ObjectId_1.ObjectId),
    likes: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    comments: zod_1.z.array(zod_1.z.instanceof(ObjectId_1.ObjectId)).default([]),
    acceptedCommentId: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    closedAt: zod_1.z.coerce.date().optional(),
    closedBy: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
});
exports.PostSchema = exports.PostBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var PostDTOSchema = exports.PostSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.PostDTO = {
    convertFromModel: function (model) {
        var _a, _b, _c, _d, _e;
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            title: model.title,
            description: model.description,
            views: model.views,
            image: model.image,
            imagePublicId: model.imagePublicId,
            pinned: model.pinned,
            channel: (0, ObjectId_1.isPopulated)(model.channel)
                ? Channel_1.ChannelDTO.convertFromModel(model.channel)
                : (_a = model.channel) === null || _a === void 0 ? void 0 : _a.toString(),
            author: (0, ObjectId_1.isPopulated)(model.author) ? User_1.UserDTO.convertFromModel(model.author) : (_b = model.author) === null || _b === void 0 ? void 0 : _b.toString(),
            likes: (0, ObjectId_1.isArrayPopulated)(model.likes)
                ? model.likes.map(function (like) { return Like_1.LikeDTO.convertFromModel(like); })
                : (_c = model.likes) === null || _c === void 0 ? void 0 : _c.map(function (like) { return like.toString(); }),
            comments: (0, ObjectId_1.isArrayPopulated)(model.comments)
                ? model.comments.map(function (comment) { return Comment_1.CommentDTO.convertFromModel(comment); })
                : (_d = model.comments) === null || _d === void 0 ? void 0 : _d.map(function (comment) { return comment.toString(); }),
            acceptedCommentId: model.acceptedCommentId ? model.acceptedCommentId.toString() : undefined,
            closedAt: model.closedAt,
            closedBy: (0, ObjectId_1.isPopulated)(model.closedBy)
                ? User_1.UserDTO.convertFromModel(model.closedBy)
                : (_e = model.closedBy) === null || _e === void 0 ? void 0 : _e.toString(),
        };
        return dto;
    },
};
var isTopicClosed = function (post) { return Boolean(post.closedAt); };
exports.isTopicClosed = isTopicClosed;
exports.closeTopicSchema = zod_1.z.object({
    closed: zod_1.z.boolean(),
});
exports.PostRequestDTOSchema = PostDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { author: (0, ObjectId_1.ObjectIdString)('Invalid author id'), channel: (0, ObjectId_1.ObjectIdString)('Invalid channel id'), likes: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid like id')), comments: zod_1.z.array((0, ObjectId_1.ObjectIdString)('Invalid comment id')) }));
exports.setAcceptedCommentSchema = zod_1.z.object({
    commentId: zod_1.z.union([(0, ObjectId_1.ObjectIdString)('Invalid comment id'), zod_1.z.null()]),
});
//# sourceMappingURL=Post.js.map